import { render, staticRenderFns } from "./LogoMarquee.vue?vue&type=template&id=c04ee846&scoped=true"
import script from "./LogoMarquee.vue?vue&type=script&lang=ts"
export * from "./LogoMarquee.vue?vue&type=script&lang=ts"
import style0 from "./LogoMarquee.vue?vue&type=style&index=0&id=c04ee846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04ee846",
  null
  
)

export default component.exports